document.addEventListener("DOMContentLoaded", async () => {
  const popupAlertContainer = document.querySelector(".cart__pop_up");
  const popupAlertText = document.querySelector("#popup-cart-text");
  const popupAlertCloseBtn = document.querySelector(".cpu__close__btn");
  if (!document.querySelectorAll("[data-atc-btn]").length) return;
  const normalizeCategory = (category) => {
    return category ? category.toLowerCase() : "dry";
  };
  const categorizeFromTags = (tagsString) => {
    if (!tagsString || typeof tagsString !== "string") {
      return "dry";
    }
    const lower = tagsString.toLowerCase();
    if (
      lower.includes("tiefkühltheke") ||
      lower.includes("tiefkuhltheke") ||
      lower.includes("deepfreeze")
    ) {
      return "deepfreeze";
    }
    if (
      lower.includes("kühltheke") ||
      lower.includes("kuhltheke") ||
      lower.includes("freeze")
    ) {
      return "freeze";
    }
    return "dry";
  };
  document.querySelectorAll("[data-atc-btn]").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      const variantId = Number(btn.dataset.variant);
      const proceedToAddToCart = async () => {
        const formData = { items: [{ id: variantId, quantity: 1 }] };
        const addRes = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
        await addRes.json();
        new theme.CartDrawer();
        const cartDrawerTrigger = document.querySelector(
          ".js-drawer-open-cart",
        );
        if (cartDrawerTrigger) cartDrawerTrigger.click();
        // updateCartBubble();
        if (typeof updateCartBubble === "function") updateCartBubble();
        // setTimeout(function () {
        //     document.dispatchEvent(new CustomEvent("cart:updated"));
        // }, 250); //added while pfand
        const category = normalizeCategory(btn.dataset.productCategory);
        console.log(`✅ Added variant ${variantId} (${category}) to cart.`);
      };
      try {
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();
        if (!cart.items.length) {
          console.log("Cart empty — adding freely.");
          await proceedToAddToCart();
          return;
        }
        const variantCategory = normalizeCategory(btn.dataset.productCategory);
        console.log(
          `Target variant ${variantId} is classified as: ${variantCategory}`,
        );
        const cartCategories = new Set();
        for (const item of cart.items) {
          try {
            const productRes = await fetch(`/products/${item.handle}.js`);
            if (productRes.ok) {
              const productData = await productRes.json();
              const category = categorizeFromTags(
                productData.tags?.join(", ") || "",
              );
              console.log(
                `Product: ${item.product_title}, Tags: ${productData.tags}, Category: ${category}`,
              );
              cartCategories.add(category);
            } else {
              console.warn(`Could not fetch product data for ${item.handle}`);
              cartCategories.add("dry");
            }
          } catch (error) {
            console.error(`Error fetching product ${item.handle}:`, error);
            cartCategories.add("dry");
          }
        }
        console.log("Current cart categories:", [...cartCategories]);
        const conflict =
          (variantCategory === "freeze" &&
            (cartCategories.has("dry") || cartCategories.has("deepfreeze"))) ||
          (variantCategory === "deepfreeze" &&
            (cartCategories.has("dry") || cartCategories.has("freeze"))) ||
          (variantCategory === "dry" &&
            (cartCategories.has("freeze") || cartCategories.has("deepfreeze")));
        if (conflict) {
          console.warn(
            `⚠️ Conflict detected for variant ${variantId}. Cannot add to cart.`,
          );
          popupAlertContainer.classList.add("open");
          const messages = {
            freeze:
              document.querySelector("#has_freeze_oncart")?.textContent || "",
            deepfreeze:
              document.querySelector("#has_deepfreeze_oncart")?.textContent ||
              "",
            dry: document.querySelector("#has_dry_oncart")?.textContent || "",
          };
          popupAlertText.textContent = messages[variantCategory] || "";
          return;
        }
        await proceedToAddToCart();
      } catch (error) {
        console.error("Error processing add-to-cart:", error);
      }
    });
  });
  if (popupAlertCloseBtn) {
    popupAlertCloseBtn.addEventListener("click", () => {
      popupAlertContainer.classList.remove("open");
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  var cartDrawer = document.getElementById("CartDrawer");
  if (cartDrawer) {
    cartDrawer.addEventListener("click", function (e) {
      var removeButton = e.target.closest(".js-remove-from-cart");
      if (removeButton) {
        e.preventDefault();
        var itemKey = removeButton.getAttribute("data-key");
        if (!itemKey) {
          console.error("No item key found");
          return;
        }
        theme.cart
          .changeItem(itemKey, 0)
          .then(function (response) {
            var cartData =
              typeof response === "string" ? JSON.parse(response) : response;
            return theme.cart.getCartProductMarkup();
          })
          .then(function (html) {
            var productsContainer = cartDrawer.querySelector("[data-products]");
            if (productsContainer && html) {
              productsContainer.innerHTML = html;
            }
            return theme.cart.getCart();
          })
          .then(function (cart) {
            var subtotalElement = cartDrawer.querySelector("[data-subtotal]");
            if (subtotalElement && cart.total_price !== undefined) {
              subtotalElement.textContent = theme.Currency.formatMoney(
                cart.total_price,
                theme.moneyFormat,
              );
            }
            var discountsContainer =
              cartDrawer.querySelector("[data-discounts]");
            if (discountsContainer) {
            }
            var cartCounts = document.querySelectorAll(
              ".cart-count, [data-cart-count]",
            );
            cartCounts.forEach(function (el) {
              el.textContent = cart.item_count;
            });
            if (cart.item_count === 0) {
              cartDrawer.classList.add("is-empty");
            }
            console.log('Item removed from cart');
            document.dispatchEvent(new CustomEvent("cart:updated")); //added while pfand
            // console.log("Item removed from cart");
          })
          .catch(function (error) {
            console.error("Error removing item:", error);
            alert("Failed to remove item. Please try again.");
          });
      }
    });
  }
});
